import React from 'react'
import { Tab } from '../../types/windows'
import './WindowContainer.css'

interface WindowContainerProps {
  tab: Tab
  onClose: () => void
}

export const WindowContainer: React.FC<WindowContainerProps> = ({ tab, onClose }) => {
  const WindowComponent = tab.component

  return (
    <div className="window-container">
      <div className="window-header">
        <div className="window-title">{tab.title}</div>
        {tab.closable && (
          <button
            className="window-close-btn"
            onClick={onClose}
            aria-label={`Close ${tab.title}`}
          >
            ×
          </button>
        )}
      </div>
      
      <div className="window-body">
        <WindowComponent {...(tab.props || {})} tabId={tab.id} tabTitle={tab.title} />
      </div>
    </div>
  )
}
